import moment from "antd/node_modules/moment";
import { action, computed, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { RegionFilterStore } from "../RegionFilterStore";

export class EngActivitiesStore {
  loading = false;

  filterStore: RegionFilterStore;

  filter: any = {
    page: 0,
    size: 20,
    regionId: "",
    divisionId: "",
    communityId: "",
    period: [undefined, undefined],
  };

  sortedInfo = { columnKey: "start", order: "descend" };

  data = {
    total: 0,
    items: [],
  };

  constructor() {
    makeAutoObservable(this, {
      pagination: computed,
    });
    this.filterStore = new RegionFilterStore(this);
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  @action onSearch(history) {
    this.onPage(history, 1, this.filter.size);
  }

  @action onPage(history, page, size) {
    let period: string[] = [];
    if (this.filter.period?.[0]) {
      period = [
        moment(this.filter.period?.[0]).format("YYYY-MM-DD"),
        moment(this.filter.period?.[1]).format("YYYY-MM-DD"),
      ];
    }
    const query = new URLSearchParams({ ...this.filter, period, page: page - 1, size });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);
    console.log("query", params);
    const regionId = params.get("regionId") || "";
    const divisionId = params.get("divisionId") || "";
    const communityId = params.get("communityId") || "";
    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "20");
    const periodStr = params.get("period") || ",";
    const period = periodStr !== "," ? periodStr.split(",").map((x) => moment(x)) : [undefined, undefined];
    this.filter = { regionId, divisionId, communityId, period, page, size };
    this.refresh();
  }

  @action
  refresh() {
    this.loading = true;
    const { regionId, divisionId, communityId, period, page, size } = this.filter;

    const sorts = this.sortedInfo.order
      ? [{ field: this.sortedInfo.columnKey, order: this.sortedInfo.order === "descend" ? "desc" : "asc" }]
      : [];

    const filter: any = {
      regionId,
      divisionId,
      communityId,
      page,
      size,
      sorts,
    };
    if (period?.[0]) {
      filter.period = [moment(period[0]).startOf("day").toISOString(), moment(period[1]).endOf("day").toISOString()];
    }
    Api.engTool
      .engActivities(filter)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.engActivities;
        });
      })
      .finally(() => (this.loading = false));
  }
}

export const engActivitiesStore = new EngActivitiesStore();
